import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'

const componentsLoaderSiteConfig: SiteConfigFn<Record<string, never>> = () => {
	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: false,
		siteConfig: null,
	}
}

const name = 'componentsLoader'

export const config = { site: componentsLoaderSiteConfig, name }
